import CourseDetail from '@views/course/CourseDetail.vue'
import TraineeDetail from '@views/course/TraineeDetail.vue'
import TraineePay from '@views/course/TraineePay.vue'
import TraineeCard from '@views/course/TraineeCard.vue'

export default [
  {
    path: '/user/course/:courseId',
    name: 'CourseDetail',
    component: CourseDetail,
    props: (route) => ({
      courseId: route.params.courseId
    }),
    meta: {
      title: '講座詳細',
      gaTitle: '講座詳細',
      nav: 'back',
      footer: true
    }
  },
  {
    path: '/user/trainee/:courseId',
    name: 'TraineeDetail',
    component: TraineeDetail,
    props: (route) => ({
      courseId: route.params.courseId
    }),
    meta: {
      title: '申込講座詳細',
      gaTitle: '申込講座詳細',
      nav: 'back',
      footer: true
    }
  },
  {
    path: '/user/trainee/:courseId/pay',
    name: 'TraineePay',
    component: TraineePay,
    props: (route) => ({
      courseId: route.params.courseId
    }),
    meta: {
      title: '申込講座支払い方法',
      gaTitle: '申込講座支払い方法',
      nav: 'back',
      footer: true
    }
  },
  {
    path: '/user/trainee/:courseId/card',
    name: 'TraineeCard',
    component: TraineeCard,
    props: (route) => ({
      courseId: route.params.courseId
    }),
    meta: {
      title: '受講票',
      gaTitle: '受講票',
      nav: 'back',
      header: false,
      footer: true
    }
  }
]
